const BlogHeader = ({ name }) => {
  return (
    <div className="blog-card-section-header">
      <h2 className="blog-card-section-header-title">{name}</h2>
    </div>
  );
};
export default BlogHeader;
